// extracted by mini-css-extract-plugin
export var dividerContainer = "_7j-0";
export var line = "_7j-1";